//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {required, minLength, email} from "vuelidate/lib/validators";

export default {
  data() {
    return {
      form: {
        attachments: [],
        name: "",
        phone: "",
        email: "",
        text: "",
      },
      isPrivacyPolicy: true,
      mailingAgreement: true,
      isConsentProcessing: true,
    };
  },
  props: {
    title: {
      type: String,
      default: "Написать письмо директору",
    },

    formType: {
      type: String,
      default: "Письмо директору",
    },
  },
  validations: {
    form: {
      name: {required, minLength: minLength(2)},
      text: {required, minLength: minLength(10)},
      email: {email},
      phone: {required, minLength: minLength(17)},
    },
  },
  methods: {
    onChangeFilesReviews({target}) {
      let newForm = {...this.form};
      const {name, value, files} = target;
      newForm[name] = [...newForm[name], ...files];
      this.form = Object.assign({}, this.form, newForm);
    },
    onCloseFilesRewiews(idx) {
      this.form?.attachments.splice(idx, 1);
    },
    async onSubmitForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return null;
      } else {
        let form = {
          type: this.formType,
          name: this.form.name,
          message: this.form.text,
          phone: `+${this.form.phone.replace(/\D+/g, "")}`,
          email: this.form.email,
          additional_data: {
            is_marketing: this.mailingAgreement
          }
        };
        let formData = new FormData();
        Object.keys(form).map((key) => {
          formData.append(key, form[key]);
        });
        Object.keys(this.form.attachments).map((key) => {
          formData.append("attachments[]", this.form.attachments[key]);
        });
        try {
          let res = await this.$api.agent.transport.post(`form/send`, formData);
          if (res) {
            this.$modal.hide('letter-modal')
            this.$router.push("/zapis/success");
          }
        } catch (error) {
          this.$modal.hide('letter-modal')
          console.log(error);
        }
      }
    },
  },
};
